export function getTwitterTags() {
  const twitterCreator = {
    property: "twitter:creator",
    content: "@taskrabbit",
  };
  const twitterSite = { property: "twitter:site", content: "@taskrabbit" };
  return [twitterCreator, twitterSite];
}
